import { ref, computed, watch, onMounted, reactive } from "vue";
import type { Ref, ComputedRef } from "vue";
import { findIndex, sortBy, isArray, get, trim, cloneDeep } from "lodash-es";

import type { DataTableColumnType, UseSortableDataType } from "../types";
import { extractTextFromVNode } from "./render/index";
interface TablePropsType {
  tableHeaders: DataTableColumnType[];
  data: any[];
}
export function useSortableData<T = any>(
  props: TablePropsType,
  colFilterData?: any
): UseSortableDataType {
  console.log("useSortableData");

  const sortColumnIndex = ref(-1); // 当前排序列的索引
  const sortOrder = ref(""); // 排序顺序，"asc" 表示升序，"desc" 表示降序

  const sortData = (prop: string) => {
    const columnIndex = findIndex(
      props.tableHeaders,
      (col) => col.prop === prop
    );

    if (columnIndex >= 0) {
      const sortColumnType = props.tableHeaders[columnIndex];

      // 切换排序顺序
      if (sortColumnIndex.value === columnIndex) {
        sortOrder.value =
          sortOrder.value === "asc"
            ? "desc"
            : sortOrder.value === "desc"
            ? ""
            : "asc";
      } else {
        sortOrder.value = "asc";
      }

      sortColumnIndex.value = columnIndex;
    }
  };
  function isNumeric(str: string): boolean {
    return /^\d+$/.test(str); // 匹配一连串数字
  }
  // 中文字符排序函数
  function chineseSort(str1, str2) {
    return str1.localeCompare(str2, "zh-Hans-CN", {
      sensitivity: "accent",
    });
  }

  // 中文和数字混合排序函数
  function mixedSort(a, b) {
    // 判断元素类型
    const typeA = typeof a;
    const typeB = typeof b;

    // 如果类型不同，直接比较类型
    if (typeA !== typeB) {
      return typeA.localeCompare(typeB);
    }

    // 如果类型相同，且为字符串，使用中文排序
    if (typeA === "string") {
      return chineseSort(a, b);
    }

    // 如果类型相同，且为数字，直接比较大小
    if (typeA === "number") {
      return a - b;
    }

    // 其他类型保持不变
    return 0;
  }
  const sortedData = computed(() => {
    let setData = props.data;
    console.log("sortedData");
    if (sortColumnIndex.value >= 0) {
      const sortColumnType = props.tableHeaders[sortColumnIndex.value];

      let sorted = sortBy(
        props.data,
        (row, i) => {
          let res = get(row, sortColumnType.prop);

          if (sortColumnType.slots && sortColumnType.slots.default) {
            const renderVnode = sortColumnType.slots.default({
              row: row,
              $index: i,
            });
            res = extractTextFromVNode(renderVnode);
          } else if (typeof sortColumnType.formatter == "function") {
            const renderVnode = sortColumnType.formatter(
              row,
              sortColumnType,
              get(row, sortColumnType.prop),
              i
            );
            res = extractTextFromVNode(renderVnode);
          } else if (typeof res == "string" && isNumeric(res)) {
            // 假如是数字
            res = Number(res);
          }

          return res;
        },
        mixedSort
      );

      if (sortOrder.value === "desc") {
        sorted = sorted.reverse();
      }

      setData = sorted;
    }

    return setData;
  });

  function getVnodeText(col:any,o:any,i:number):string{
    let cellStr=""
    if (col.slots && col.slots.default) {
      cellStr = extractTextFromVNode(
        col.slots.default({
          row: o,
          $index: i,
        })
      );
    } else if (typeof col.formatter == "function") {
      cellStr = extractTextFromVNode(
        col.formatter(o, col, get(o, col.prop), i)
      );
    } else {
      cellStr = get(o, col.prop) || "   ";
    }
    return cellStr
  }
  const sortOrOrgData = computed(() => {
    let setData: any[] = isArray(props.data)
      ? sortOrder.value
        ? sortedData.value
        : props.data
      : [];

    let ObjectFilterKeys = Object.keys(cloneDeep(colFilterData.valMap)).filter(
      (o) => !!o&&!!trim(colFilterData.valMap[o]||"")
    );
    if (ObjectFilterKeys.length) {
      let newSetData = [];

      setData.map((o,i) => {
        let isIsFilterRow = true;
        for (let i = 0; i < ObjectFilterKeys.length; i++) {
          let propKey = ObjectFilterKeys[i];
          let vals = colFilterData.valMap[propKey].split("\n").filter(o=>!!o);

          let isMoreValCheck = false;

          vals.map((oval) => {
            
            if (getVnodeText(colFilterData.colMap[propKey],o,i).indexOf(oval) >=0) {
              isMoreValCheck = true;
            }
          });
           
          
          if (!isMoreValCheck) {
            isIsFilterRow = false;
            break;
          }
        }
        if (isIsFilterRow) {
          newSetData.push(o);
        }
      });
      setData = newSetData;
    }

    setData.map((o, i) => {
      setData[i].__orgIdx = i;
    });
    return setData;
  });
  function clearSort() {
    sortColumnIndex.value = -1;
    sortOrder.value = "";
  }
  watch(
    () => props.tableHeaders,
    () => {
      sortColumnIndex.value = -1;
      sortOrder.value = "";
    }
  );

  return {
    colFilterData,
    sortOrOrgData,
    sortColumnIndex,
    sortOrder,
    sortedData,
    sortData,
    clearSort,
  };
}
